module.exports = __webpack_public_path__ + "static/media/by.8ed77d9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/by.svg
// module id = 77
// module chunks = 0